import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import Base, { Label } from '@atlaskit/field-base';
import TextArea from './styled/TextArea';

// We are using any as FieldTextArea passes props via spread
// TODO: if there is no impact props should be passed explicitly from FieldTextArea
var FieldTextAreaStateless = function (_Component) {
  _inherits(FieldTextAreaStateless, _Component);

  function FieldTextAreaStateless() {
    _classCallCheck(this, FieldTextAreaStateless);

    return _possibleConstructorReturn(this, (FieldTextAreaStateless.__proto__ || _Object$getPrototypeOf(FieldTextAreaStateless)).apply(this, arguments));
  }

  _createClass(FieldTextAreaStateless, [{
    key: 'focus',
    value: function focus() {
      this.input.focus();
    } // eslint-disable-line react/sort-comp

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoFocus = _props.autoFocus,
          compact = _props.compact,
          disabled = _props.disabled,
          id = _props.id,
          invalidMessage = _props.invalidMessage,
          isInvalid = _props.isInvalid,
          isLabelHidden = _props.isLabelHidden,
          isReadOnly = _props.isReadOnly,
          isSpellCheckEnabled = _props.isSpellCheckEnabled,
          label = _props.label,
          maxLength = _props.maxLength,
          minimumRows = _props.minimumRows,
          name = _props.name,
          onChange = _props.onChange,
          placeholder = _props.placeholder,
          enableResize = _props.enableResize,
          required = _props.required,
          shouldFitContainer = _props.shouldFitContainer,
          value = _props.value,
          isValidationHidden = _props.isValidationHidden;


      return React.createElement(
        'div',
        null,
        React.createElement(Label, {
          htmlFor: id,
          isDisabled: disabled,
          isLabelHidden: isLabelHidden,
          isRequired: required,
          label: label
        }),
        React.createElement(
          Base,
          {
            isCompact: compact,
            isDisabled: disabled,
            isInvalid: isInvalid,
            isReadOnly: isReadOnly,
            isRequired: required,
            invalidMessage: invalidMessage,
            isFitContainerWidthEnabled: shouldFitContainer,
            isValidationHidden: isValidationHidden
          },
          React.createElement(TextArea, {
            disabled: disabled,
            readOnly: isReadOnly,
            name: name,
            placeholder: placeholder,
            value: value,
            required: required,
            minimumRows: minimumRows,
            enableResize: enableResize || disabled,
            onChange: onChange,
            id: id,
            autoFocus: autoFocus,
            spellCheck: isSpellCheckEnabled,
            maxLength: maxLength,
            innerRef: function innerRef(input) {
              _this2.input = input;
            }
          })
        )
      );
    }
  }]);

  return FieldTextAreaStateless;
}(Component);

FieldTextAreaStateless.defaultProps = {
  compact: false,
  disabled: false,
  isReadOnly: false,
  required: false,
  isInvalid: false,
  type: 'text',
  isSpellCheckEnabled: true,
  minimumRows: 1,
  isValidationHidden: false
};
export default FieldTextAreaStateless;